import * as v from 'valibot';
import { IdSchema, TimestampSchema } from './common.js';
export const ArchiveJobStatusSchema = v.picklist([
    'pending',
    'processing',
    'completed',
    'failed',
    'expired'
]);
export const CreateArchiveSchema = v.object({
    roomId: IdSchema,
    parentId: v.optional(v.nullable(IdSchema)),
    fileIds: v.optional(v.array(IdSchema), []),
    folderIds: v.optional(v.array(IdSchema), [])
});
export const ArchiveJobSchema = v.object({
    id: IdSchema,
    roomId: IdSchema,
    requestedBy: IdSchema,
    status: ArchiveJobStatusSchema,
    fileCount: v.pipe(v.number(), v.integer(), v.minValue(0)),
    processedFileCount: v.pipe(v.number(), v.integer(), v.minValue(0)),
    totalBytes: v.pipe(v.number(), v.integer(), v.minValue(0)),
    processedBytes: v.pipe(v.number(), v.integer(), v.minValue(0)),
    filename: v.pipe(v.string(), v.minLength(1)),
    error: v.optional(v.nullable(v.string())),
    createdAt: TimestampSchema,
    startedAt: v.optional(v.nullable(TimestampSchema)),
    completedAt: v.optional(v.nullable(TimestampSchema)),
    expiresAt: v.optional(v.nullable(TimestampSchema))
});
//# sourceMappingURL=archive.js.map